@if (ready$ | async) {
  <form [formGroup]="dealForm" novalidate (submit)="saveDeal()">
    <div class="tc-table-page-header" tc-sticky-header fxLayoutAlign="space-between center">
      <div fxFlex>
        <div class="mat-headline-6">
          TradeCafé - {{title$ | async}}
          <tc-locks [resourceId]="dealId$" resourceType="deal"></tc-locks>
          <tc-finance-issues [detailsForm]="detailsForm"></tc-finance-issues>
          <tc-deal-view-incomplete #incomplete [dealViewRaw$]="dealViewRaw$"></tc-deal-view-incomplete>
          <tc-forex-warning [deal]="dealRaw$"></tc-forex-warning>
        </div>
        @if (dealId$ | async) {
          <small>
            {{dealId$ | async}}
            @if (isClone$ | async) {
              @if (isPrimaryClone$ | async) {
                This is the parent deal of a clone series
              } @else {
                This is a clone deal from parent deal
                @if (cloneFrom$ | async; as clonedFrom) {
                  <a [routerLink]="'/trading/deals/' + clonedFrom">
                    {{clonedFrom}}
                  </a>
                }
              }
            }
            @if (isCopy$ | async) {
              <div>
                This deal was copied from
                @if (copyFrom$ | async; as copyFrom) {
                  <a [routerLink]="'/trading/deals/' + copyFrom">
                    {{copyFrom}}
                  </a>
                }
              </div>
            }
          </small>
        }
      </div>
      @if (!modalDisplay) {
        <button type="button" mat-button color="link" (click)="goBack()">
          <i class="fa fa-times"></i> Back
        </button>
        @if (dealId$ | async) {
          <a mat-button color="link"
            href="/logistics/shipping-log/{{dealId$ | async}}"
            (click)="$event.stopPropagation();$event.preventDefault(); goToShippingView()"
            [disabled]="inProgress$ | async">
            <i class="fa-brands fa-wpforms"></i> Logistics View
          </a>
        }
      }
      <button type="submit" mat-button color="link"
        [class.tc-dirty-badge]="isDirtyAndValid$ | async"
        [class.tc-invalid-badge]="isInvalid$ | async"
        [matTooltip]="(fieldsReport$ | async) || incomplete.incomplete"
        matTooltipClass="pre-tooltip"
        matTooltipShowDelay="10000"
        [disabled]="(inProgress$ | async) || !!incomplete.incomplete">
        <i class="fa fa-fw"
          [class.fa-save]="(inProgress$ | async) !== 'save'"
          [class.fa-spin]="(inProgress$ | async) === 'save'"
          [class.fa-spinner]="(inProgress$ | async) === 'save'"
        ></i>
        {{(isSubmitted$ | async) ? 'Save Deal' : 'Save Draft'}}
      </button>
      <mat-divider [vertical]="true" style="height: 50px; margin: 0 30px 0 15px"></mat-divider>
      @if (!(isNew$ | async)) {
        <span
          [matMenuTriggerFor]="actionsMenu"
          #trigger="matMenuTrigger"
          style="display:inline-block;margin: 0 10px 0 15px"
        >
          <button
            type="button"
            mat-raised-button
            color="action"
            (click)="onActionClick($event, trigger)"
          >
            <i class="fa fa-square-caret-down"></i> Action
          </button>
        </span>
      }
      @if (!(isSubmitted$ | async)) {
        <button type="button" mat-raised-button color="add" data-test="confirm-deal-button"
          [matTooltip]="incomplete.incomplete"
          matTooltipClass="pre-tooltip"
          [disabled]="(inProgress$ | async) || !!incomplete.incomplete"
          (click)="submitDeal()">
          <i class="fa fa-fw"
            [class.fa-paper-plane]="(inProgress$ | async) !== 'submit'"
            [class.fa-spin]="(inProgress$ | async) === 'submit'"
            [class.fa-spinner]="(inProgress$ | async) === 'submit'"
          ></i>
          Confirm
        </button>
      }
      @if (!(isLocked$ | async) && (isSubmitted$ | async)) {
        <button type="button" mat-raised-button color="add"
          [disabled]="inProgress$ | async"
          (click)="lockDeal(true)">
          <i class="fa fa-fw"
            [class.fa-lock]="(inProgress$ | async) !== 'lock'"
            [class.fa-spin]="(inProgress$ | async) === 'lock'"
            [class.fa-spinner]="(inProgress$ | async) === 'lock'"
          ></i>
          Lock
        </button>
      }
    </div>
    <div class="main-form">
      <section class="top-section">
        <tc-epoch-field format="L" placeholder="Date" data-test="date-input"
          [group]="detailsForm" ctrlName="date"
        ></tc-epoch-field>
        <mat-form-field>
          <mat-label>Deal number</mat-label>
          <form (submit)="$event.stopPropagation(); $event.preventDefault()">
            <input matInput [formControl]="dealIdForm" autocomplete="off" data-test="deal-number-search">
            <button type="submit" style="display: none"></button>
          </form>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Status</mat-label>
          <input readonly matInput [value]="dealStatus$ | async">
          <i matSuffix class="fa fa-2x"
            [class.fa-lock]="!!(isLocked$ | async)"
            [class.fa-unlock]="!(isLocked$ | async)"
          ></i>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Partial Margin (%)</mat-label>
          <input readonly matInput [value]="detailsForm.partialMarginP$ | async">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Partial Margin (CAD)</mat-label>
          <input readonly matInput [value]="detailsForm.partialMarginCad$ | async">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Partial Revenue (CAD)</mat-label>
          <input readonly matInput [value]="detailsForm.partialRevenueCad$ | async">
        </mat-form-field>
      </section>
      <mat-tab-group
        preserveContent
        [selectedIndex]="activeTabIndex$ | async"
        (selectedIndexChange)="setActiveTab($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <span [class.tc-invalid]="detailsTabInvalid$ | async">Deal Details</span>
            <!-- <tc-badge-invalid form="detailsTabInvalid$ | async"></tc-badge-invalid> -->
          </ng-template>
          <tc-deal-details-v2
            [dealId]="dealId$ | async"
            [dealForm]="dealForm"
            [dealViewRaw$]="dealViewRaw$"
            [costs$]="costs$"
            (updateCost)="updateCost($event)"
            (removeCost)="removeCost($event)"
          ></tc-deal-details-v2>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span [class.tc-invalid]="specsTabInvalid$ | async">Product Specifications</span>
            <!-- <tc-badge-invalid form="specsTabInvalid$ | async"></tc-badge-invalid> -->
          </ng-template>
          <tc-deal-specs [productsForm]="productsForm"></tc-deal-specs>
        </mat-tab>
        <mat-tab label="Attachments">
          <ng-template matTabContent>
            <tc-offer-attachments
              [fileIds$]="attachmentFileIds$"
              [prefillFileIds$]="prefillAttachments$"
              [isVisible]="(activeTabIndex$ | async) === 2"
              [readonly]="!(canEditAttachments$ | async)"
              [productPicControl]="true"
              [productPicFileId]="attachmentsPicFileId"
              [techSpecControl]="true"
              [techSpecFileId]="attachmentsTechSpecFileId"
              (valueChange)="onAttachmentsChange($event)"
            ></tc-offer-attachments>
          </ng-template>
        </mat-tab>
        <mat-tab label="Logistics Costs">
          <header class="tc-logistics-costs-header" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <span flex></span>
            <button mat-raised-button color="primary" type="button" (click)="showAddCost()">
              <i class="fa fa-plus-square"></i> Add New
            </button>
            <span
              [matTooltip]="(isAddFreightDisabled$ | async) ? addFreightDisabledTooltip : ''"
              matTooltipPosition="above">
              <button mat-raised-button color="primary" type="button" (click)="showAddFreight()"
                [disabled]="isAddFreightDisabled$ | async">
                <i class="fa fa-plus-square"></i> Add Freight
              </button>
            </span>
            @if (!(isNew$ | async)) {
              <button mat-raised-button color="primary" type="button" (click)="showAddCredit()">
                <i class="fa fa-plus-square"></i> Add Credit
              </button>
            }
          </header>
          <tc-costs-list [types]="['tertiary']"
            [units]="productsForm.controls[0].controls.supplierMeasureId.value"
            [dealViewRaw]="dealViewRaw$ | async"
            [costsForm]="costsForm"
            [fxRates]="fxRates$ | async"
            [fxRatesRange]="fxRatesAskRange$ | async"
            [vendorCredits]="vendorCredits$ | async"
            [creditNotes]="creditNotes$ | async"
            (updateCost)="updateCost($event)"
            (removeCost)="removeCost($event)"
            (creditNotesChanged)="creditNotesChanged($event)"
            (vendorCreditsChanged)="vendorCreditsChanged($event)"
          ></tc-costs-list>
        </mat-tab>
        <mat-tab label="Shipping">
          <header class="tc-segments-header" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <span flex></span>
            @if (!isTrader) {
              <button type="button" class="btn btn-primary pull-right" (click)="showAddSegment()" data-test="add-segment-btn">
                <i class="fa fa-plus-square" aria-hidden="true"></i> Add Segment
              </button>
            }
          </header>
          <tc-segments-list-v2
            [dealViewRaw$]="dealViewRaw$"
            [segmentsForm]="segmentsForm"
            [fxRates]="fxRates$ | async"
            [canRemoveSegment]="!isTrader"
            (updateSegment)="showUpdateSegment($event)"
            (removeSegment)="showRemoveSegment($event)"
          ></tc-segments-list-v2>
        </mat-tab>
        <mat-tab label="Default Costs">
          <tc-costs-list [types]="['secondary']"
            [units]="productsForm.controls[0].controls.supplierMeasureId.value"
            [dealViewRaw]="dealViewRaw$ | async"
            [costsForm]="costsForm"
            [fxRates]="fxRates$ | async"
            [fxRatesRange]="fxRatesAskRange$ | async"
            [vendorCredits]="vendorCredits$ | async"
            [creditNotes]="creditNotes$ | async"
            [displayColumns]="['type','service','actAmt','estAmt','fxRate','actAmtCAD','estAmtCAD','partialAmtCAD','costUnit','invoiceStatus']"
            (creditNotesChanged)="creditNotesChanged($event)"
            (vendorCreditsChanged)="vendorCreditsChanged($event)"
          ></tc-costs-list>
        </mat-tab>
        <mat-tab label="Clones" [disabled]="isNew$ | async">
          <tc-deal-clones-v2 #dealClones [dealViewRaw$]="dealViewRaw$"></tc-deal-clones-v2>
        </mat-tab>
        <mat-tab label="Logs" [disabled]="isNew$ | async">
          <tc-audit-log-filters
            [tableIdentity]="tableIdentity">
          </tc-audit-log-filters>
          @if (!(isNew$ | async)) {
            <tc-audit-log
              [tableIdentity]="tableIdentity"
              [filter]="auditLogFilter$ | async"
            ></tc-audit-log>
          }
        </mat-tab>
      </mat-tab-group>
    </div>
  </form>
}

<mat-menu #actionsMenu="matMenu" color="primary">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="previewDocuments(DealPartyE.supplier)"
      [disabled]="isConfirmationDisabled$ | async">
      <i class="fa fa-fw fa-file-pdf"></i> Preview Supplier Documents
    </button>
    <button mat-menu-item (click)="previewDocuments(DealPartyE.buyer)"
      [disabled]="isConfirmationDisabled$ | async">
      <i class="fa fa-fw fa-file-pdf"></i> Preview Buyer Documents
    </button>
    @if (isBrokerageDeal$ | async) {
      <button mat-menu-item (click)="previewDocuments(DealPartyE.brokerage_customer)"
        [disabled]="isConfirmationDisabled$ | async">
        <i class="fa fa-fw fa-file-pdf"></i> Preview Brokerage Documents
      </button>
    }
    <button mat-menu-item (click)="sendConfirmation(DealPartyE.supplier)"
      [disabled]="isConfirmationDisabled$ | async">
      <i class="fa fa-fw fa-paper-plane"></i> {{sendConfirmationLabel(DealPartyE.supplier) | async}}
    </button>
    @if (isBrokerageDeal$ | async) {
      <button mat-menu-item (click)="sendConfirmation(DealPartyE.brokerage_customer)"
        [disabled]="isConfirmationDisabled$ | async">
        <i class="fa fa-fw fa-paper-plane"></i> {{sendConfirmationLabel(DealPartyE.brokerage_customer) | async}}
      </button>
    }
    <button mat-menu-item (click)="sendConfirmation(DealPartyE.buyer)"
      [disabled]="isConfirmationDisabled$ | async">
      <i class="fa fa-fw fa-paper-plane"></i> {{sendConfirmationLabel(DealPartyE.buyer) | async}}
    </button>
    @if (canCreateSupplierOffer$ | async) {
      <button mat-menu-item (click)="showCreateOffer()"
        [disabled]="isConfirmationDisabled$ | async">
        <i class="fa fa-fw fa-gift"></i> Create Supplier Offer
      </button>
    }
    @if (hasActiveSupplierOffer(supplierOffer)) {
      <button mat-menu-item (click)="showSupplierOffer()"
        [disabled]="isConfirmationDisabled$ | async">
        <i class="fa fa-fw fa-gift"></i> View Supplier Offer
      </button>
    }
    @if (supplierOffer) {
      <button mat-menu-item (click)="showMatchedOffers()">
        <i class="fa fa-fw fa-gift"></i> View Matched Offers
      </button>
    }
    @if (automatedOfferLink$ | async; as automatedOffer) {
      <button mat-menu-item (click)="openAutomatedOffer(automatedOffer.automated_offer_id)" [title]="automatedOffer.automated_offer_id">
        <i class="fa fa-fw fa-triangle-exclamation" style="color: #e56910" aria-hidden="true"></i>
        {{automatedOffer.automated_offer_id | fakeId:'AO-'}} ({{AutomatedOfferStatus[automatedOffer.automated_offer_status]}})
      </button>
    }
    @if (isClonesTabSelected$ | async) {
      <mat-divider></mat-divider>
    }
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="showChangeParty(DealPartyE.supplier)"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-users"></i> Change Supplier
      </button>
    }
    @if ((isClonesTabSelected$ | async) && !(areSelectedDealsClosed$ | async)) {
      <button mat-menu-item (click)="showChangeParty(DealPartyE.buyer)"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-users"></i> Change Buyer
      </button>
    }
    @if ((isBrokerageDeal$ | async) && (isClonesTabSelected$ | async)) {
      <button mat-menu-item (click)="showChangeBrokerageParty()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-users"></i> Change Brokerage Customer
      </button>
    }
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="setSpecialInstructions(DealPartyE.supplier)"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-users"></i> Change Supplier Special Instructions
      </button>
    }
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="setSpecialInstructions(DealPartyE.buyer)"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-users"></i> Change Buyer Special Instructions
      </button>
    }
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="showChangeCloneDetails()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-pen-to-square"></i> Change Clone Details
      </button>
    }
    @if ((isClonesTabSelected$ | async) && cloneActionsEnabled) {
      <button mat-menu-item (click)="addCloneTertiaryCost()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-coins"></i> Add Tertiary Cost
      </button>
      <button mat-menu-item (click)="addCloneFreightRates()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-truck"></i> Add Freight Rates
      </button>
      <button mat-menu-item (click)="changeCloneDeliveryLocation()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-location-dot"></i> Change Delivery Location
      </button>
    }
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="showReferenceNumbersModal()"
        [disabled]="noSelectedClones$ | async">
        <i class="fa fa-fw fa-square-n"></i> Reference Numbers
      </button>
    }
    <mat-divider></mat-divider>
    @if (isClonesTabSelected$ | async) {
      <button mat-menu-item (click)="showExportGrid()">
        <i class="fa fa-fw fa-cloud-arrow-down"></i> Download to CSV
      </button>
    }
    <button mat-menu-item (click)="showCloneDeal()" [disabled]="canNotClone$ | async">
      <i class="fa fa-fw fa-copy"></i> Clone Deal
    </button>
    <button mat-menu-item (click)="copyDeal()">
      <i class="fa fa-fw fa-clipboard"></i> Copy Deal
    </button>
    @if (!(isLocked$ | async) && (isSubmitted$ | async)) {
      <button mat-menu-item (click)="lockDeal(true)"
        [disabled]="inProgress$ | async">
        <i class="fa fa-fw"
          [class.fa-lock]="(inProgress$ | async) !== 'lock'"
          [class.fa-spin]="(inProgress$ | async) === 'lock'"
          [class.fa-spinner]="(inProgress$ | async) === 'lock'"
          ></i> Lock Deal
      </button>
    }
    @if (isAdmin && (isLocked$ | async)) {
      <button mat-menu-item (click)="lockDeal(false)"
        [disabled]="!(isSubmitted$ | async) || (inProgress$ | async)">
        <i class="fa fa-fw"
          [class.fa-unlock]="(inProgress$ | async) !== 'lock'"
          [class.fa-spin]="(inProgress$ | async) === 'lock'"
          [class.fa-spinner]="(inProgress$ | async) === 'lock'"
          ></i> Unlock Deal
      </button>
    }
    <button mat-menu-item disabled="true">
      <i class="fa fa-fw fa-trash-can"></i> Delete Deal
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="showDealMessages()" [disabled]="isNew$ | async">
      <i class="fa fa-fw fa-comments"></i> Access Messages
    </button>
    <button mat-menu-item (click)="showDealNotes()" [disabled]="isNew$ | async">
      <i class="fa fa-fw fa-pencil"></i> Add/See Notes
    </button>
    <button mat-menu-item (click)="showDealDocuments()" [disabled]="isNew$ | async">
      <i class="fa fa-fw fa-copy"></i> Add/See Documents
    </button>
    <button mat-menu-item (click)="showAddCredit()" [disabled]="isNew$ | async">
      <i class="fa fa-fw fa-copy"></i> Add Credit
    </button>
    @if (canCreatePrepayment$ | async) {
      <button mat-menu-item (click)="showRequestPrepayment()" [disabled]="isNew$ | async">
        <i class="fa fa-fw fa-message-dollar"></i> Request Prepayment
    </button>
    }
  </ng-template>
</mat-menu>
